import * as React from "react";
import * as __intl__ from "@frameio/i18n";
import { type FilterKeys } from "../../../../types";
export type Text = {
    clearAll: string;
    filterTrigger: string;
    filterTriggerAriaLabel: string;
    filterTriggerAriaLabelWithCount: (count: number) => string;
    menuLabel: string;
    filterOptionLabel: (key: FilterKeys) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Clear filters button label and aria-label */
            clearAll: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchFilter.clearAll?c=2tdge0d9wlhny", defaultMessage: "Clear All" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text label for the filter menu trigger */
            filterTrigger: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchFilter.filterTrigger?c=2m0k36gpkzavt", defaultMessage: "Filter" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the filter menu trigger when no filters are active */
            filterTriggerAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchFilter.filterTriggerAriaLabel?c=2csgfzn0xr0x9", defaultMessage: "Filter results" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the filter menu trigger when filters are active */
            filterTriggerAriaLabelWithCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "QuickSearchFilter.filterTriggerAriaLabelWithCount?c=2sd3d47a9e6hg", defaultMessage: "Filter results, {count} active {count, plural, one {filter} other {filters}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu group label describing what the checkboxes filter */
            menuLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchFilter.menuLabel?c=kpy3xk8cr37c", defaultMessage: "Filter results by" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Filter option label based on filter key */
            filterOptionLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (key: FilterKeys): string => __intl__.intl().formatMessage({ id: "QuickSearchFilter.filterOptionLabel?c=1o46e4zhnkfsf", defaultMessage: "{key, select, assets {Asset} folders {Folder} projects {Project} other {}}" }, { key: key }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
